import React from 'react';
import {
  Box,
  Button,
  VStack,
  Input,
  useColorModeValue,
} from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const PlanForm = ({
  category,
  setCategory,
  content,
  setContent,
  handleSave,
  onBack,
}) => {
  const bg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  return (
    <Box bg={bg} p={8} borderRadius="3xl" boxShadow="xl">
      <Button
        variant="ghost"
        leftIcon={<ArrowBackIcon />}
        mb={6}
        onClick={onBack}
      >
        Back
      </Button>
      <VStack spacing={6} align="stretch">
        <Input
          placeholder="Enter Plan Name"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        />
        <Box
          border="1px solid"
          borderColor={borderColor}
          borderRadius="md"
          overflow="hidden"
        >
          <ReactQuill
            theme="snow"
            value={content}
            onChange={setContent}
            style={{ height: '300px', marginBottom: '45px' }}
            modules={{
              toolbar: [
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                [{ font: [] }],
                [{ size: [] }],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [
                  { list: 'ordered' },
                  { list: 'bullet' },
                  { indent: '-1' },
                  { indent: '+1' },
                ],
                ['link', 'image', 'video'],
                [{ color: [] }, { background: [] }],
                [{ align: [] }],
                ['clean'],
              ],
            }}
          />
        </Box>
        <Box>
          <Button colorScheme="teal" size="lg" onClick={handleSave}>
            Publish Changes
          </Button>
        </Box>
      </VStack>
    </Box>
  );
};

export default PlanForm;
